// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5257": "88225f65","5395": "7bf34428","888": "8cf3ee70","8990": "7d69c8cd",}[chunkId] + ".css"
}